<template>
  <div class="header">
    <div class="company-info">
      <div class="clientName ">{{ clientDetails?.organisationName }}</div>
      <div class="clientAddress">{{ `${clientDetails.locations&&clientDetails?.locations.length>0?clientDetails?.locations?.[0].address1:''} ${clientDetails.locations&&clientDetails?.locations.length>0?clientDetails?.locations?.[0].address2:''}`  }}</div>
      <!-- <br>
        {{ `${clientDetails.locations&&clientDetails?.locations.length>0?clientDetails?.locations?.[0].city:''} ${clientDetails.locations&&clientDetails?.locations.length>0?clientDetails?.locations?.[0].state:''}`}} -->
         
      <!-- <div class="clientAddress">{{`Phone:${clientDetails.locations&&clientDetails?.locations.length>0?clientDetails?.locations?.[0].phone_no:''}`}}</div> -->
    </div>
    <!-- <div class="ambassador-wrapper" >
      <div v-for="(item, i) in ambassadorData" :key="i">
        <AmbassadorCard :name="item.name" :mail="item.email" v-if="item.role === 'CSR'"/>
      </div> 
      <div class="brands"> 
        <v-img
          style="margin: 0 auto"
          src="./clientLogo.svg"
          height="40px"
          width="auto"
        ></v-img>
        <v-btn size="30" @click="drawer = !drawer" icon>
          <v-icon>mdi-account</v-icon>
        </v-btn>
      </div>
    </div> -->
  </div>
  <v-layout>
    <!-- <v-navigation-drawer
      v-model="drawer"
      location="right"
      width="400"
      class="pa-5"
      temporary
    >
      <div class="drawer-heading">
        <h3>Owner & Sales reps</h3>
        <v-btn size="20" @click="drawer = !drawer" icon>
          <v-icon size="15">mdi-close</v-icon>
        </v-btn>
      </div>
      <div class="drawer">
        <div v-for="(item, i) in ambassadorData" :key="i">
          <AmbassadorCard :name="item.name" :mail="item.email" :icon="item.icon" v-if="item.role === 'CSR'"/>
        </div>

        <OwnerDetails />
      </div>
    </v-navigation-drawer> -->
  </v-layout>
</template>

<script>
// import AmbassadorCard from "@/components/AmbassadorCard.vue";
// import OwnerDetails from "../ClientDetails/PointOfContanct/OwnerDetails.vue";
export default {
  props: {
    clientDetails: {
      type: Object,
      required: true
    }
  },
  components: { 
    // AmbassadorCard, 
    // OwnerDetails 
  },
  data() {
    return {
      drawer:false,
      ambassadorData: [
        { name: "Radica Hajaree", email: "radica@coreforce.com", role:"CSR",icon:'mdi-account-tie-outline'},
        { name: "Client Ambassador", email: "radica@coreforce.com", role:"CSR",icon:'mdi-handshake-outline'},
        // { name: "Tibura Solutions", email: "support@tibura.com", role:"CMP"},
      ],
    };
  },
  methods : {
      
  },

  mounted(){
  }

};
</script>

<style lang="scss" scoped>
.drawer-heading{
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px;
  border-bottom:1px solid #ccc ;
  margin-bottom: 15px;
}
.drawer{
  display: flex;
  flex-direction: column;
  gap: 15px;
}
.brands{
  display: flex;
  align-items: center;
  gap: 15px;
}
.header {
  display: flex;
  align-items: center;
  width: 100%;
  gap: 4%;

  @media (max-width: 768px) {
    flex-wrap: wrap;
  }

  @media (max-width: 480px) {
    flex-wrap: wrap;
  }

  .company-info {
    text-wrap: nowrap;
    text-align: left;
    margin-bottom: 10px;
    .clientName {
      font-size: 24px;
      font-weight: 700;
    }
    .clientAddress {
      font-size: 14px;
      font-weight: 400;
    }
  }

  .ambassador-wrapper {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 20px;
    align-items: end;

    @media (max-width: 768px) {
      grid-template-columns: repeat(2, 1fr);
    }

    @media (max-width: 480px) {
      grid-template-columns: 1fr;
    }
  }

  .ambassador-wrapper > div:nth-last-child(1) {
    grid-column: 4;

    @media (max-width: 768px) {
      grid-column: 1;
    }

    @media (max-width: 480px) {
      grid-column: 1;
    }
  }
}
</style>
